export class ConstantMessages {
    public Success: any;
    public Error: any;
    
    constructor() {
       
        this.Error = {
            MandatoryDataNull: 'All fields highlighted in red are mandatory, please enter the details and click on Save.',

        }

    }

}